import { createTranslateLoader } from './utilities/createTranslateLoader';
// pipe
import { GetDateStringLabelPipe } from './pipes/getDateStringLabelPipe';
import { TimeStringLabelPipe } from './pipes/timeStringLabelPipe';
import { CustomFilterPipe } from './pipes/custom-filter.pipe';
var THIRDMODULES = [];
// #endregion
// #region your componets & directives
var COMPONENTS = [];
var DIRECTIVES = [];
var PIPES = [GetDateStringLabelPipe, TimeStringLabelPipe, CustomFilterPipe];
var ɵ0 = createTranslateLoader;
// #endregion
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };
